export default {
  init() {
    Kadenze.WebApp.initializePjax();
  }
};
